<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M3.552 0H.586A.586.586 0 0 0 0 .586v2.966c0 .323.262.586.586.586h2.966a.586.586 0 0 0 .586-.586V.586A.586.586 0 0 0 3.552 0z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M19.414 0h-2.966a.586.586 0 0 0-.586.586v2.966c0 .323.263.586.586.586h2.966A.586.586 0 0 0 20 3.552V.586A.586.586 0 0 0 19.414 0z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M3.552 15.862H.586a.586.586 0 0 0-.586.586v2.966c0 .324.262.586.586.586h2.966a.586.586 0 0 0 .586-.586v-2.966a.586.586 0 0 0-.586-.586z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M19.414 15.862h-2.966a.586.586 0 0 0-.586.586v2.966c0 .324.263.586.586.586h2.966a.586.586 0 0 0 .586-.586v-2.966a.586.586 0 0 0-.586-.586z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M17.345 5.316h1.172v9.38h-1.172z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M5.31 1.483h9.38v1.172H5.31z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M1.483 5.316h1.172v9.38H1.483z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M5.31 17.345h9.38v1.172H5.31z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#F6F5F8',
    },
    size: {
      type: Number,
      default: 20,
    },
  },
};
</script>
